<template>
  <div>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="items"
      :server-items-length="meta.total"
      :footer-props="footerProps"
      :options="options"
      :page="page"
      :items-per-page="itemsPerPage"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :multi-sort="multiSort"
      v-on="listeners"
    >
      <template v-slot:item.created_at="{ item }">
        {{ item.created_at | dateFormat }}
      </template>

      <template v-slot:item.customer="{ item }">
        <span class="mr-2">{{ item.customer }}</span>
        <router-link
          class="text-decoration-none"
          target="_blank"
          :to="
            item.person_id
              ? {
                  name: 'persons.show',
                  params: { id: item.person_id }
                }
              : item.company_id
              ? {
                  name: 'companies.show',
                  params: { id: item.company_id }
                }
              : ''
          "
        >
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon small v-on="on">mdi-eye-outline</v-icon>
            </template>
            <span v-if="item.customer">{{ item.customer }}</span>
            <span v-else>{{ $t('ITEM.VIEW') }}</span>
          </v-tooltip>
        </router-link>
      </template>

      <template v-slot:item.date_from="{ item }">
        {{ item.date_from | dateFormat }}
      </template>

      <template v-slot:item.date_to="{ item }">
        {{ item.date_to | dateFormat }}
      </template>

      <template v-slot:item.status="{ item }">
        <v-chip :color="item.status_color" text-color="white">
          {{ item.status }}
        </v-chip>
      </template>

      <template v-slot:item.action="{ item }">
        <div class="text-center">
          <v-list-item @click="$emit('show', item)">
            <v-list-item-title>
              <v-icon class="mr-1" small>mdi-eye</v-icon>
              {{ $t('ITEM.VIEW') }}
            </v-list-item-title>
          </v-list-item>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { dateFormat } from '@/modules/_global/filters';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import listItems from '@/modules/_global/mixins/list-items';

export default {
  name: 'BookingReservationsList',

  filters: { dateFormat },

  mixins: [i18nRefreshData, listItems],

  data: () => ({
    unwatch: null
  }),

  computed: {
    headers() {
      return [
        {
          text: this.$t('ITEM.ID'),
          align: 'left',
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('ITEM.DATE_ENTERED'),
          sortable: true,
          value: 'created_at'
        },
        {
          text: this.$t('BOOKING.RESOURCES.ITEM'),
          sortable: true,
          value: 'title'
        },
        {
          text: this.$t('BOOKING.RESERVATIONS.CUSTOMER'),
          sortable: true,
          value: 'customer'
        },
        {
          text: this.$t('BUILDING_COMPLEXES.ITEM'),
          sortable: true,
          value: 'building_complex_name'
        },
        {
          text: this.$t('BUILDINGS.ITEM'),
          sortable: true,
          value: 'building_street'
        },
        {
          text: this.$t('ITEM.DATE_FROM'),
          sortable: true,
          value: 'date_from'
        },
        {
          text: this.$t('ITEM.DATE_TO'),
          sortable: true,
          value: 'date_to'
        },
        {
          text: this.$t('ITEM.TIME_FROM'),
          sortable: true,
          value: 'time_from'
        },
        {
          text: this.$t('ITEM.TIME_TO'),
          sortable: true,
          value: 'time_to'
        },
        {
          text: this.$t('ITEM.STATUS'),
          sortable: true,
          value: 'status'
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'action',
          sortable: false,
          align: 'center'
        }
      ];
    }
  },

  methods: {}
};
</script>
